module.exports = __webpack_public_path__ + "quote-top.png?242fad51c4c5501fee28ba4cea49b717";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quote-top.png
// module id = 12
// module chunks = 0